import { BotMessageSquare, ChartCandlestick, FileChartLine, FileChartPie, FileChartPieIcon, FileSliders, MessageSquareReply, ScatterChart, ScrollText, UserCog } from "lucide-react";
import { ConversationType } from "./chat.constant";


export const NAVIGATION_ITEMS = [
  {
    title: "CHOP GPT",
    type: ConversationType.CHOP_GPT,
    icon: BotMessageSquare,
    iconColor: 'bg-agent-chopgpt',
    navigation: `/chat/${ConversationType.CHOP_GPT.toLowerCase()}`
  },
  {
    title: "Policy Assistant",
    type: ConversationType.POLICY_ASSISTANT,
    icon: ScrollText,
    iconColor: 'bg-agent-policygpt',
    navigation: `/chat/${ConversationType.POLICY_ASSISTANT.toLowerCase()}`
  }
];
export const ADMIN_PANEL_NAVIGATION_ITEMS = [
  {
    title: "User Manager",
    icon: UserCog,
    navigation: "/admin/user-manager"

  },
  {
    title: "Feedback Manager",
    icon: MessageSquareReply,
    navigation: "/admin/feedback-manager"
  },
  {
    title: "Chat Metrics",
    icon: ScatterChart,
    navigation: "/admin/chat-metrics"
  },
  {
    title: "Corpus Manager",
    icon: FileSliders,
    navigation: "/admin/corpus-manager"

  },
  {
    title: "Monitor & Evaluator",
    icon: ChartCandlestick,
    children: [
      {
        title: "Overall Response Validator",
        icon: FileChartLine,
        navigation: "/admin/monitor/overall-response"
      },
      {
        title: "Live Response monitor",
        icon: FileChartPieIcon,
        navigation: "/admin/monitor/live-response"

      },
    ],
  },
];
